import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.53 15.607a.71.71 0 0 1-.225.53.702.702 0 0 1-.523.224.74.74 0 0 1-.543-.224.72.72 0 0 1-.217-.53V3.545c0-.253-.123-.38-.367-.38H5.347c-.244 0-.367.127-.367.38v12.062a.71.71 0 0 1-.224.53.71.71 0 0 1-.53.224.732.732 0 0 1-.536-.224.72.72 0 0 1-.217-.53V3.375c0-.525.156-.941.468-1.25.317-.312.743-.468 1.277-.468h7.566c.534 0 .957.156 1.27.469.317.308.475.724.475 1.25v12.231Zm-2.323.238c0 .081-.028.138-.082.17-.054.036-.124.036-.21 0l-2.092-.904a.53.53 0 0 1-.19-.122.297.297 0 0 1-.055-.19V5.202c0-.081.018-.144.055-.19a.53.53 0 0 1 .19-.122l2.092-.903c.086-.036.156-.036.21 0 .054.031.082.088.082.17v11.688Z" }, null, -1)
  ]))]))
}
export default { render: render }